var Modernizr = require("../../vendors/modernizr.min");
var $ = require("jquery");

var bodyMobilePopoverOpenClass = "ws-body--mobile-popover-open";
var popoverSelector = '[data-ws-toggle="popover"]';
let BsPopover = null;

if (Modernizr.browsertouch) {
    $(document).on("click", popoverSelector, function (e) {
        e.preventDefault();
        loadAndTriggerPopover(this);
    });

    // trigger popovers for keyboard navigation on mobile devices
    $(document).on("keyup", popoverSelector, function (event) {
        var keyCode = (event.keyCode ? event.keyCode : event.which);
        if (keyCode === 9) { // TAB key
            event.preventDefault();
            loadAndTriggerPopover(this);
        }
    });
} else {
    $(document).on("focus", popoverSelector, function (e) {
        e.preventDefault();
        if (/MSIE|Trident/.test(window.navigator.userAgent)) {
            // IE does not support obj param; calculate viewport middle
            window.scrollTo(0, (e.target.getBoundingClientRect().top + window.pageYOffset) - (window.innerHeight / 2));
        }
        else {
            e.target.scrollIntoView({ block: "center" });
        }

        loadAndTriggerPopover(this);
    });

    $(document).on("mouseover", popoverSelector, function () {
        // trigger the popover on hover on desktop
        loadAndTriggerPopover(this);
    });

    $(document).on("mouseleave", popoverSelector, function () {
        // close the popover on hover leave on desktop
        closePopovers();
    });
}

$(document).on("focusout", popoverSelector, function (e) {
    e.preventDefault();
    closePopovers();
});

function clickOutsideOfPopover(e) {
    // close the popover when the user clicks anywhere on the page, except within the popover itself or the trigger element
    var selectors = '.ws-ajax-popover, .ws-popover-trigger, .popover, [data-bs-toggle="popover"]';
    if (!$(e.target).is(selectors) && !$(e.target).parents(selectors).length) {
        closePopovers($('.ws-popover-opened'));
    }
}

function triggerPopoverHelper($triggerElement, options) {
    options = options || {};
    var content = $triggerElement.data("content");

    if (!content) {
        var source = $($triggerElement.data("contentSource"));
        content = $(source).html();
        $triggerElement.data("content", content);
    }

    if (!content) {
        return false;
    }

    var theme = $triggerElement.data("popover-theme");
    var placement = $triggerElement.data("placement");
    var $dialog = $triggerElement.closest(".ws-dialog");
    var defaultOptions = {
        html: true,
        trigger: "manual",
        content: content,
        template: `<div class="popover ws-popover ${placement} ${theme}  ${($dialog.length > 0 ? 'ws-popover--location_fs-dialog' : '')}" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>`,
        container: "html",
        placement: placement
    };
    var finalOptions = $.extend({}, defaultOptions, options);

    $triggerElement.popover(finalOptions);
    $triggerElement.popover("toggle");
    $triggerElement.toggleClass("ws-popover-opened");
    return true;
}

function loadAndTriggerPopover(triggerElement) {
    if (BsPopover) {
        triggerPopover(triggerElement);
    } else {
        import(/* webpackChunkName: "bspopover" */ "bootstrap/js/dist/popover").then(({ default: bsPopover }) => {
            BsPopover = bsPopover;
            triggerPopover(triggerElement);
        });
    }
}

function triggerPopover(triggerElement) {
    closePopovers($(".ws-popover-opened").not(triggerElement));
    var $triggerElement = $(triggerElement);
    var popoverTriggered = triggerPopoverHelper($triggerElement);

    if (!popoverTriggered) {
        return;
    }

    $(document).on("click", clickOutsideOfPopover);
    $(document.body).toggleClass(bodyMobilePopoverOpenClass, true);

    if (Modernizr.browsertouch) {
        $triggerElement.toggleClass("ws-popover-toggle");
    }
}

function closePopovers($popovers) {
    // default to all opened popovers, if none are passed in
    $popovers = $popovers || $(".ws-popover-opened");

    // hide the popovers
    $popovers.popover("hide");
    $popovers.removeClass("ws-popover-opened");
    $popovers.removeClass("ws-popover-toggle");

    // remove document click handler
    $(document).off("click", clickOutsideOfPopover);
    $(document.body).removeClass(bodyMobilePopoverOpenClass);
}

function notificationPopover(triggerElement) {
    var $triggerElement = $(triggerElement);
    if ($triggerElement.hasClass("ws-popover-opened")) {
        closePopovers($triggerElement);
        clearTimeout($triggerElement.data("popover-timeout"));
    }

    var popoverTriggered = triggerPopoverHelper($triggerElement, { placement: ($triggerElement.data("placement") || "bottom") });
    if (!popoverTriggered) {
        return;
    }

    var timeout = setTimeout(function () {
        closePopovers($triggerElement);
        $triggerElement.removeData("popover-timeout");
    }, 100);

    $triggerElement.data("popover-timeout", timeout);
}

exports.notificationPopover = notificationPopover;
